import { StoreCreator, createStoreWithMiddleware } from '@/shared/store';
import { create } from 'zustand';
import type { User } from './types';

interface AuthState {
  user: User | null;
  setUser: (user: User | null) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  /**
   * SSR 에서 세션 쿠키 존재 여부를 미리 알 수 있을 때 store 를 hydration.
   * 쿠키 있음 → isAuthenticated=true, isLoading=true 로 user fetch 대기 진입.
   * 쿠키 없음 → isAuthenticated=false, isLoading=false 로 비로그인 즉시 확정.
   * 헤더가 첫 paint 부터 "로그인" 버튼을 잘못 노출하는 깜빡임 방지.
   */
  hydrate: (initialIsAuthenticated: boolean) => void;
}

const authStateCreator: StoreCreator<AuthState> = (set) => ({
  user: null,
  isLoading: true,
  isAuthenticated: false,
  setUser: (user) => set({ user }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
  hydrate: (initialIsAuthenticated) =>
    set({
      isAuthenticated: initialIsAuthenticated,
      isLoading: initialIsAuthenticated,
    }),
});

const useAuthStore = create<AuthState>()(
  createStoreWithMiddleware(authStateCreator, 'AuthStore'),
);

export default useAuthStore;
